import { ExternalLink } from 'lucide-react';

const ARTICLES = [
  {
    name: 'The Hindu',
    url: 'https://www.thehindu.com/news/cities/bangalore/in-the-age-of-age-tech-how-bengalurus-elderly-are-getting-empowered/article69430340.ece',
    excerpt: 'In the age of age-tech, how Bengaluru\'s elderly are getting empowered',
    logoUrl: 'https://customer-assets.emergentagent.com/job_95459019-fd40-417d-bf1f-43659b4169ce/artifacts/t94zvruy_the-hindu-logo.png',
  },
  {
    name: 'The Better India',
    url: 'https://www.instagram.com/p/DQy7un7iCF-/',
    excerpt: 'Featured story on Elderra\'s mission',
    logoUrl: 'https://customer-assets.emergentagent.com/job_95459019-fd40-417d-bf1f-43659b4169ce/artifacts/qs2r9pbc_The_Better_India_id4voN7PrB_0.png',
  },
  {
    name: 'The Federal',
    url: 'https://thefederal.com/category/news/digital-arrest-scam-victims-law-enforcement-failure-226061',
    excerpt: 'Digital arrest scams: Why elderly are at the highest risk',
    logoUrl: 'https://customer-assets.emergentagent.com/job_95459019-fd40-417d-bf1f-43659b4169ce/artifacts/b6xly8cy_The%20federal%20logo.png',
  },
];

const MediaCoverage = () => {
  return (
    <section className="media-coverage" data-testid="media-coverage-section">
      <div className="container">
        <div className="media-coverage-header">
          <span className="media-eyebrow">As featured in</span>
          <h2>In the news</h2>
          <p>Press coverage and stories from across India.</p>
        </div>

        <div className="media-grid">
          {ARTICLES.map((a, idx) => (
            <a
              key={a.name}
              href={a.url}
              target="_blank"
              rel="noopener noreferrer"
              className="media-card"
              data-testid={`media-card-${idx}`}
            >
              <div className="media-logo-wrap">
                <img
                  src={a.logoUrl}
                  alt={`${a.name} logo`}
                  className="media-logo"
                  loading="lazy"
                  onError={(e) => {
                    // Fallback: hide image and show text instead
                    e.currentTarget.style.display = 'none';
                    const fallback = e.currentTarget.nextElementSibling;
                    if (fallback) fallback.style.display = 'flex';
                  }}
                />
                <div className="media-logo-fallback" style={{ display: 'none' }}>
                  {a.name}
                </div>
              </div>
              <div className="media-card-body">
                <div className="media-card-name">{a.name}</div>
                <p className="media-card-excerpt">{a.excerpt}</p>
                <span className="media-card-link">
                  Read article <ExternalLink size={13} />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MediaCoverage;
